import { render, staticRenderFns } from "./TestItemEdit.vue?vue&type=template&id=61cf4c56&scoped=true"
import script from "./TestItemEdit.vue?vue&type=script&lang=js"
export * from "./TestItemEdit.vue?vue&type=script&lang=js"
import style0 from "./TestItemEdit.vue?vue&type=style&index=0&id=61cf4c56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cf4c56",
  null
  
)

export default component.exports